/**
 * 船機遙測查詢（`display.telemetry.read` 權限）。
 *
 * 船機隨 `POST /api/cms/update` 把導覽播放次數、GPS 與系統狀態一起送上來
 * （規格書 §15）。那些是**累計值**，這裡拿到的統計已經由後端換算成區間增量。
 */

import { apiFetch, buildQueryString, type Schemas } from './core';

export type TelemetryRecord = Schemas['TelemetryRecordDto'];
export type TelemetryListResult = Schemas['TelemetryListResponseDto'];
export type GuidePlaysReport = Schemas['GuidePlaysReportDto'];
export type PlayBucket = Schemas['PlayBucketDto'];

export type PlayGranularity = 'day' | 'week' | 'month';

/** 原始回報流水（最近的在前）。統計看起來不對時要能翻回原始值。 */
export function listDisplayTelemetry(params: {
  limit?: number;
  offset?: number;
}): Promise<TelemetryListResult> {
  return apiFetch<TelemetryListResult>(`/admin/display-telemetry${buildQueryString(params)}`, {
    method: 'GET',
  });
}

/**
 * 導覽播放統計。
 *
 * `from` / `to` 為日界且 `to` 含當日，以 Asia/Taipei 解讀。
 */
export function fetchGuidePlays(params: {
  from: string;
  to: string;
  granularity?: PlayGranularity;
}): Promise<GuidePlaysReport> {
  return apiFetch<GuidePlaysReport>(
    `/admin/display-telemetry/guide-plays${buildQueryString(params)}`,
    { method: 'GET' },
  );
}
